import { baseApi } from './baseApi';

export const recommendationsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllLatestRecommendations: builder.query({
      query: () => '/crypto-currency/recommendations',
      providesTags: ['Recommendations'],
    }),
    getRecommendationById: builder.query({
      query: (id) => `/crypto-currency/recommendations/${id}`,
      providesTags: (result, error, id) => [{ type: 'Recommendation', id }],
    }),
    getRecommendationsByCryptoCurrencyId: builder.query({
      query: (cryptoCurrencyId) => `/crypto-currency/${cryptoCurrencyId}/recommendations`,
      providesTags: (result, error, cryptoCurrencyId) => [
        { type: 'CryptoCurrencyRecommendations', id: cryptoCurrencyId }
      ],
    }),
    createRecommendation: builder.mutation({
      query: (cryptoCurrencyId) => ({
        url: `/crypto-currency/${cryptoCurrencyId}/recommendations`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, cryptoCurrencyId) => [
        'Recommendations',
        { type: 'CryptoCurrencyRecommendations', id: cryptoCurrencyId },
      ],
    }),
    deleteRecommendation: builder.mutation({
      query: (id) => ({
        url: `/crypto-currency/recommendations/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, id) => [
        'Recommendations',
        { type: 'Recommendation', id },
      ],
    }),
  }),
  overrideExisting: false,
});


